import React from "react";

// Custom line icons (stroke 1.6) for Ranger Base.
const base = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const wrap = (children) => (props) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...base} {...props}>
    {children}
  </svg>
);

export const ICONS = {
  Carbon: wrap(
    <>
      <circle cx="16" cy="16" r="5" />
      <path d="M16 4v3M16 25v3M4 16h3M25 16h3M7.5 7.5l2.1 2.1M22.4 22.4l2.1 2.1M24.5 7.5l-2.1 2.1M9.6 22.4l-2.1 2.1" />
    </>
  ),
  NativeSeed: wrap(
    <>
      <path d="M16 28c0-6 3-11 8-13-2 6-4 11-8 13Z" />
      <path d="M16 28c0-6-3-11-8-13 2 6 4 11 8 13Z" />
      <path d="M16 28V14" />
      <circle cx="16" cy="9" r="4" />
    </>
  ),
  Biodiversity: wrap(
    <>
      <path d="M6 26c6 0 10-4 10-10M26 26c-6 0-10-4-10-10" />
      <path d="M16 16c0-5 3-9 7-11-1 5-3 9-7 11Z" />
      <path d="M16 16c0-5-3-9-7-11 1 5 3 9 7 11Z" />
      <path d="M16 26v-4" />
    </>
  ),
  Culture: wrap(
    <>
      <path d="M16 4c3 4 3 8 0 12-3-4-3-8 0-12Z" />
      <path d="M16 16v12" />
      <path d="M10 22c2-1 4-1 6 0M22 22c-2-1-4-1-6 0" />
      <circle cx="16" cy="16" r="1" />
    </>
  ),
  Fire: wrap(
    <>
      <path d="M16 4c1 4 5 5 5 10a5 5 0 0 1-10 0c0-2 1-3 2-4" />
      <path d="M16 28a4 4 0 0 0 4-4c0-2-2-3-4-6-2 3-4 4-4 6a4 4 0 0 0 4 4Z" />
    </>
  ),
  GIS: wrap(
    <>
      <path d="M6 8l7-2 6 2 7-2v18l-7 2-6-2-7 2V8Z" />
      <path d="M13 6v18M19 8v18" />
    </>
  ),
  Leadership: wrap(
    <>
      <circle cx="16" cy="9" r="4" />
      <path d="M8 26c0-5 3.5-8 8-8s8 3 8 8" />
      <path d="M16 4V2M12 14l-2 2M20 14l2 2" />
    </>
  ),
  Monitoring: wrap(
    <>
      <circle cx="14" cy="14" r="7" />
      <path d="M19 19l7 7" />
      <path d="M14 11v6M11 14h6" />
    </>
  ),
  Country: wrap(
    <>
      <path d="M4 22l6-8 4 5 4-6 6 9" />
      <path d="M3 26h26" />
      <circle cx="22" cy="8" r="3" />
    </>
  ),
  Partnerships: wrap(
    <>
      <circle cx="11" cy="12" r="4" />
      <circle cx="21" cy="12" r="4" />
      <path d="M4 26c0-4 3-6 7-6M28 26c0-4-3-6-7-6" />
      <path d="M13 20h6" />
    </>
  ),
  Governance: wrap(
    <>
      <path d="M6 12l10-6 10 6" />
      <path d="M8 12v10M16 12v10M24 12v10" />
      <path d="M5 26h22" />
    </>
  ),
  Enterprise: wrap(
    <>
      <path d="M5 27V13l7-4 7 4v14" />
      <path d="M19 27V11l8 3v13" />
      <path d="M4 27h24" />
      <path d="M9 16h2M9 20h2M23 18h1.5M23 22h1.5" />
    </>
  ),
};

export const Icon = ({ name, className = "", ...rest }) => {
  const Cmp = ICONS[name] || ICONS.Country;
  return <Cmp className={className} {...rest} />;
};

export default Icon;
